import * as React from 'react';

import { Button } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';

import styles from './SideFiltersFormFooter.module.css';

export interface SideFiltersFormFooterProps {
  submitButtonText: string;
  resetSideFilters: () => void;
}

export const SideFiltersFormFooter = ({
  submitButtonText,
  resetSideFilters,
}: SideFiltersFormFooterProps) => {
  const { T } = useIntl();

  return (
    <div className={styles.root}>
      <div className={styles.filterButtons}>
        <Button
          className={styles.button}
          color="secondary"
          size="large"
          variant="text"
          onClick={resetSideFilters}
        >
          {T('search_page.filters.clear_filters')}
        </Button>
        <Button
          className={styles.button}
          color="secondary"
          variant="contained"
          type="submit"
          role="button"
        >
          {submitButtonText}
        </Button>
      </div>
    </div>
  );
};
